import { render, staticRenderFns } from "./Bando26Fase7.vue?vue&type=template&id=badf5d26&scoped=true"
import script from "./Bando26Fase7.vue?vue&type=script&lang=js"
export * from "./Bando26Fase7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badf5d26",
  null
  
)

export default component.exports